<template lang="pug">
#Results
    .results(v-if="results")
        div(v-if="results.length")
            h4 Your address is in the following designated transport areas.
            p Click "Show on map" to see a school and its designated transport area.
            SchoolInfo(v-for="result in results" :school="result" :selected="result.Entity_Code === selectedEntityCode" :key="result.Entity_Code")
        div(v-else)
            h4 This address is not within a designated transport area.
            p Your designated neighbourhood primary and secondary schools and nearest specialist schools can still be found on <a href="https://findmyschool.vic.gov.au">Find my School</a>.
    .loading.gray.f3(v-show="loading")
        p Looking up your address now...
    .loading.red.f3(v-show="error")
        p Address lookup service unavailable.
</template>

<script>
import { EventBus } from '../EventBus';
import SchoolInfo from './SchoolInfo';
export default {
    name: 'Results',
    components: {
        SchoolInfo,
    },
    data: () => ({
        results: undefined,
        selectedEntityCode: undefined,
        loading: false,
        error: false,
    }),
    created() {
        window.Results = this;
        EventBus.$on('boundary-results', (results) => {
            this.loading = false;
            this.error = false;
            if (!results) {
                this.results = [];
                return;
            }
            // this.results = results.sort((r1, r2) => r1.Specialisation < r2.Specialisation ? -1 : 1);
            this.results = condenseResults(results).sort(
                (r1, r2) => (r1.School_Name < r2.School_Name ? -1 : 1)
            );
        });
        EventBus.$on('select-dta', (boundary) => {
            this.selectedEntityCode = boundary.Entity_Code;
        });
        EventBus.$on('start-geocode', () => {
            this.results = null;
            this.loading = true;
            this.error = false;
        });
        EventBus.$on('geocode-error', () => {
            this.results = null;
            this.error = true;
        });
        EventBus.$on('geocode-suggest', () => {
            this.results = null;
            this.error = false;
        });
    },
    watch: {
        results() {
            this.showDesc = false;
        },
    },
};
function condenseResults(results) {
    const entities = {};
    results.forEach(
        (r) =>
            (entities[r.Entity_Code] = [...(entities[r.Entity_Code] || []), r])
    );
    return Object.keys(entities).map((e) => {
        const out = entities[e][0];
        out.DTA_Types = entities[e].map((r) => r.DTA_Type);
        return out;
    });
}
</script>

<style scoped>
.loading,
.results {
    /* transition: color 0.5 ease; */
    animation: fadeIn ease 0.3s;
}

@keyframes fadeIn {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
</style>
